import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { oidcClientIds } from './GenericUserManager';
import DesktopUserManagerSwitch from './DesktopUserManagerSwitch';
import MobileUserManagerSwitch from './MobileUserManagerSwitch';
import BrowserUserManager from './BrowserUserManager';

const UserManagerSwitch = ({
  children,
  basePath,
  silentRedirectUri,
  oidcAuthority,
  clientId,
  postLogoutRedirectUri,
  onSessionLoaded,
  silentRenewDisabled,
  externalExpired,
}) => {
  const isDesktopApp = useMemo(() => !!window.top.electron, []);
  const isMobileApp = useMemo(() => !!window.top.flutter_inappwebview, []);

  if (isDesktopApp) {
    return (
      <DesktopUserManagerSwitch
        basePath={basePath}
        onSessionLoaded={onSessionLoaded}
        silentRenewDisabled={silentRenewDisabled}
        externalExpired={externalExpired}
        oidcAuthority={oidcAuthority}
        silentRedirectUri={silentRedirectUri}
        clientId={clientId}
        postLogoutRedirectUri={postLogoutRedirectUri}
      >
        {children}
      </DesktopUserManagerSwitch>
    );
  }

  if (isMobileApp) {
    return (
      <MobileUserManagerSwitch
        basePath={basePath}
        silentRedirectUri={silentRedirectUri}
        oidcAuthority={oidcAuthority}
        clientId={clientId}
        postLogoutRedirectUri={postLogoutRedirectUri}
        onSessionLoaded={onSessionLoaded}
        silentRenewDisabled={silentRenewDisabled}
        externalExpired={externalExpired}
      >
        {children}
      </MobileUserManagerSwitch>
    );
  }

  return (
    <BrowserUserManager
      basePath={basePath}
      silentRedirectUri={silentRedirectUri}
      oidcAuthority={oidcAuthority}
      clientId={clientId}
      postLogoutRedirectUri={postLogoutRedirectUri}
      onSessionLoaded={onSessionLoaded}
      silentRenewDisabled={silentRenewDisabled}
      externalExpired={externalExpired}
    >
      {children}
    </BrowserUserManager>
  );
};

// ######################################################################################
// ## PropTypes
// ######################################################################################

UserManagerSwitch.propTypes = {
  children: PropTypes.node.isRequired,
  basePath: PropTypes.string.isRequired,
  oidcAuthority: PropTypes.string.isRequired,
  clientId: PropTypes.oneOf(Object.values(oidcClientIds)).isRequired,
  postLogoutRedirectUri: PropTypes.string.isRequired,
  onSessionLoaded: PropTypes.func,
  silentRenewDisabled: PropTypes.bool,
  externalExpired: PropTypes.bool,
  silentRedirectUri: PropTypes.string,
};

UserManagerSwitch.defaultProps = {
  onSessionLoaded: () => {},
  silentRenewDisabled: false,
  silentRedirectUri: '',
  externalExpired: false,
};

export default UserManagerSwitch;
